import { Chip, SvgIcon } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AlignLeft02Icon from "../../icons/untitled-ui/duocolor/align-left-02";
import BarChartSquare02Icon from "../../icons/untitled-ui/duocolor/bar-chart-square-02";
import Building04Icon from "../../icons/untitled-ui/duocolor/building-04";
import CalendarIcon from "../../icons/untitled-ui/duocolor/calendar";
import CheckDone01Icon from "../../icons/untitled-ui/duocolor/check-done-01";
import CreditCard01Icon from "../../icons/untitled-ui/duocolor/credit-card-01";
import CurrencyBitcoinCircleIcon from "../../icons/untitled-ui/duocolor/currency-bitcoin-circle";
import File01Icon from "../../icons/untitled-ui/duocolor/file-01";
import GraduationHat01Icon from "../../icons/untitled-ui/duocolor/graduation-hat-01";
import HomeSmileIcon from "../../icons/untitled-ui/duocolor/home-smile";
import LayoutAlt02Icon from "../../icons/untitled-ui/duocolor/layout-alt-02";
import LineChartUp04Icon from "../../icons/untitled-ui/duocolor/line-chart-up-04";
import Lock01Icon from "../../icons/untitled-ui/duocolor/lock-01";
import LogOut01Icon from "../../icons/untitled-ui/duocolor/log-out-01";
import Mail03Icon from "../../icons/untitled-ui/duocolor/mail-03";
import Mail04Icon from "../../icons/untitled-ui/duocolor/mail-04";
import MessageChatSquareIcon from "../../icons/untitled-ui/duocolor/message-chat-square";
import ReceiptCheckIcon from "../../icons/untitled-ui/duocolor/receipt-check";
import Share07Icon from "../../icons/untitled-ui/duocolor/share-07";
import ShoppingBag03Icon from "../../icons/untitled-ui/duocolor/shopping-bag-03";
import ShoppingCart01Icon from "../../icons/untitled-ui/duocolor/shopping-cart-01";
import Truck01Icon from "../../icons/untitled-ui/duocolor/truck-01";
import Upload04Icon from "../../icons/untitled-ui/duocolor/upload-04";
import Users03Icon from "../../icons/untitled-ui/duocolor/users-03";
import XSquareIcon from "../../icons/untitled-ui/duocolor/x-square";

export const getSections = (t) => [
  {
    items: [
      {
        title: "Parlamentares",
        path: "/",
        icon: (
          <SvgIcon fontSize="small">
            <Users03Icon />
          </SvgIcon>
        ),
      },
      {
        title: "Pautas legislativas",
        path: "/pautas",
        icon: (
          <SvgIcon fontSize="small">
            <LayoutAlt02Icon />
          </SvgIcon>
        ),
      },
      {
        title: "Sessões Plenárias",
        path: "/sessoes",
        icon: (
          <SvgIcon fontSize="small">
            <CheckDone01Icon />
          </SvgIcon>
        ),
      },
      {
        title: "Plenário Digital",
        path: "/plenario-digital",
        icon: (
          <SvgIcon fontSize="small">
            <MessageChatSquareIcon />
          </SvgIcon>
        ),
        items: [
          {
            title: "Sessões em Pauta",
            path: "/plenario-digital/sessoes",
          },
        ],
      },
    ],
  },
];
